import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}`;

export const checkAuthentication = async () => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await axios.get(`${API_URL}/auth/check`, {
      withCredentials: true,
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    
    return response.data.isAuthenticated;
  } catch (error) {
    // Silêncio deliberado (at-60): o único consumidor é a tela de login, que usa o
    // retorno apenas para decidir se redireciona uma sessão ainda válida. A falha
    // dominante aqui é o 401 de token expirado — o caminho esperado —, e a
    // consequência (permanecer na tela de login) já é visível ao usuário. Um erro
    // real de rede aparece em seguida, no próprio login.
    console.error('Erro ao verificar a autenticação', error);
    return false;
  }
};
